export const api_config = {
  baseUrl: import.meta.env.VITE_API_URL,
};
